import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DataService } from 'app/shared/services/data/data.service';
import { UserService } from 'app/shared/services/user/user.service';

@Component({
  selector: 'app-confirm-reset',
  templateUrl: './confirm-reset.component.html',
  styleUrls: ['./confirm-reset.component.scss']
})
export class ConfirmResetComponent implements OnInit {

  isReset = false;

  constructor(
    public dialogRef: MatDialogRef<ConfirmResetComponent>,
    private userService: UserService,
    private dataService: DataService
  ) { }

  ngOnInit(): void {
  }

  confirmReset(): void {
    this.userService.resetOrderMenu().subscribe(res => {
      this.dataService.menu.next(res);
      this.isReset = true;
      setTimeout(() => {
        this.dialogRef.close();
        this.isReset = false;
      }, 2500);
    });
  }
}
